module.exports = __webpack_public_path__ + "img/feihe.84febcf6.png";